import React from 'react';
import { FilterName } from '@jetshop/ui/Filter/FilterAccordion';
import ListFilterList from '@jetshop/ui/Filter/FilterTypes/List/ListFilterList';
const ListFilterAccordion = ({ listFilters, accordionProps, startingIdx = 0 }) => {
    const { AccordionContent } = accordionProps;
    return (React.createElement(React.Fragment, null, listFilters.map((filter, idx) => (React.createElement(React.Fragment, { key: filter.id },
        React.createElement(FilterName, { accordionProps: accordionProps, idx: idx + startingIdx, filter: filter }),
        React.createElement(AccordionContent, { isOpen: accordionProps.openIndexes.includes(idx + startingIdx) },
            React.createElement(ListFilterList, { id: filter.id, filters: filter.items })))))));
};
export default ListFilterAccordion;
//# sourceMappingURL=ListFilterAccordion.js.map